const isTruthy = (value) => value === true || value === 'true' || value === 1;

export const hasCadastrosReadPermission = (user) => {
  if (isTruthy(user?.permissionWebAssistencia?.cadastros?.read)) {
    return true;
  }
  return (
    isTruthy(user?.permission?.assistencias?.read) ||
    isTruthy(user?.permission?.assistencias?.write)
  );
};

export const hasCadastrosWritePermission = (user) => {
  if (isTruthy(user?.permissionWebAssistencia?.cadastros?.write)) {
    return true;
  }
  return isTruthy(user?.permission?.assistencias?.write);
};

export const formatAssistenciaMoney = (assistencia, value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '—';
  const currency = assistencia?.currency || 'BRL';
  const locale = assistencia?.format || (currency === 'USD' ? 'en-US' : 'pt-BR');
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
};

export const getAssistenciaUnitPrice = (assistencia) => {
  const valor = Number(assistencia?.valor) || 0;
  const desconto = assistencia?.desconto;
  if (desconto != null && desconto !== '' && Number.isFinite(Number(desconto))) {
    return Math.max(0, valor - Number(desconto));
  }
  return valor;
};
